import React, { Fragment, useEffect } from "react";
import { SvgLoader } from "../../utils/svgLoader.tsx";
import { SidebarNavigationProps } from "./data/appsData";
import "./SidebarNavigation.css";
import { useSelector } from "react-redux";

export const SidebarNavigation: React.FC<SidebarNavigationProps> = ({
  items,
  onNavigate,
}) => {
  const {
    globalReducer: { userData, selectedWorkspace },
  } = useSelector((state: any) => state);

  const [isUserMember, setIsUserMember] = React.useState(false);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace._id) {
      console.log("SidebarNavigation: User and Workspace data is available");
      if (selectedWorkspace && selectedWorkspace.role === "member") {
        setIsUserMember(true);
      } else {
        setIsUserMember(false);
      }
    }
  }, [selectedWorkspace]);

  return (
    <div className="box-border content-stretch flex flex-col gap-1 items-center justify-start p-0 relative shrink-0 w-full optoins">
      {items.map((item) => {
        if (isUserMember && item.id === "billing") {
          return <Fragment key={item.id} />;
        }
        return (
          <div
            key={item.id}
            className={`${
              item.active
                ? "app-sidebar-nav-item-active"
                : "app-sidebar-nav-item"
            } option ${
              item.id === "stripe-products" ? "stripe-products-menu-item" : ""
            }`}
            onClick={() => onNavigate(item.id, item)}
            style={{ cursor: "pointer" }}
          >
            <div className="app-sidebar-nav-item-content">
              <div className="app-sidebar-nav-item-inner w-full h-full">
                <div
                  className={
                    item.active
                      ? "app-sidebar-nav-item-icon-active"
                      : "app-sidebar-nav-item-icon"
                  }
                >
                  <SvgLoader name={item.icon} width={24} height={24} />
                </div>
                <div className="app-sidebar-nav-item-text service-name">
                  <p className="block leading-[18px] whitespace-pre">
                    {item.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
